import type {PromotionTool} from 'modules/Services/PromotionCenter/types';

import {Button} from '@ds/components';

type PromotionToolCardProps = {
  tool: PromotionTool;
  onClick: () => void;
};

const PromotionToolCard: React.FC<PromotionToolCardProps> = ({tool, onClick}) => {
  return (
    <Button
      variant="ghost"
      color="secondary"
      disableWave
      fullWidth
      className="h-34 min-h-34 flex-col gap-3 rounded-lg border-gray-22 bg-white px-4 py-4 text-neutral-fg shadow-md hover:bg-white hover:text-neutral-fg active:bg-white"
      onClick={onClick}
    >
      <img className="size-10" src={tool.image} alt="" aria-hidden />
      <span className="text-center text-subtitle-sm text-neutral-fg">{tool.title}</span>
    </Button>
  );
};

export default PromotionToolCard;
